import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import LanguageManager from "../../../../manager/language_manager";
import TimeManager from "../../../../manager/time_manager";
import ViewBase from "../../../../framework/core/mvvm/view_base";
import GameUtil from "../../../../utility/game_util";
import PrefabsHolder from "../../../public/component/prefabsHolder";

const { ccclass, property } = cc._decorator;

@ccclass
export default class CommonSettingItem extends cc.Component{
    @property(cc.Sprite)
    itemIcon:cc.Sprite = null

    @property(cc.Node)
    bgNode:cc.Node = null

    @property(cc.Node)
    buyBtn:cc.Node = null

    @property(cc.Node)
    xufeiBtn:cc.Node = null

    @property(cc.Node)
    suoNode:cc.Node = null

    @property(cc.Node)
    gouNode:cc.Node = null

    @property(cc.Node)
    chooseNode:cc.Node = null

    @property(SpriteFrameHolder)
    spriteAtlas:SpriteFrameHolder = null

    @property(cc.Prefab)
    prefabAtlas:cc.Prefab = null


    m_prefabsHolder = null
    mAnimKeyMap: Map<string, cc.Node> = new Map<string, cc.Node>()
    itemData = null
    viewBase = null

    onLoad(){

    }

    getAnimNodeByKey(key: string){
        let node = this.mAnimKeyMap.get(key)
        if(!node){
            if(this.m_prefabsHolder){
                node = this.m_prefabsHolder.getNodeByKey(key)
                this.mAnimKeyMap.set(key, node)
            }            
        }
        return node
    }

    showInfo(data, viewBase:ViewBase){ 
        if(this.prefabAtlas && this.m_prefabsHolder == null){
            let node = cc.instantiate(this.prefabAtlas)
            node.parent = this.node
            node.active = false
            this.m_prefabsHolder = node.getComponent(PrefabsHolder)                         
        }   

        this.viewBase = viewBase
        let self = this
        this.itemData = data
        if (data.isGoods){
            this.buyBtn.active = !data.isHave
            this.suoNode.active = !data.isHave 
            this.xufeiBtn.active = data.isHave
        }
        else
        {
            this.xufeiBtn.active = false
            this.buyBtn.active = false
            this.suoNode.active = false
        }
        //this.gouNode.active = false
        //三个替换 处理可能有些许差异
        switch(data.plizedType){
            case "head_img":
               
                break;
            case "head_frame":
                if (data.plizedCode == "empty"){
                    self.itemIcon.enabled = true
                }
                else{
                    self.itemIcon.enabled = false
                    let node = this.getAnimNodeByKey(data.plizedCode)
                    if (node != null){   
                        node.parent = self.itemIcon.node
                        node.zIndex = -1
                        node.position = cc.Vec3.ZERO
                        node.active = true
                    }
                }

                break;
            case "card_icon":
                this.itemIcon.spriteFrame = this.spriteAtlas.getSpriteFrameByKey(data.plizedCode)
                break;
            default:
                break;
        }
        this.bgNode.on('click', this.onChooseEvent, this)
        this.buyBtn.on('click', this.onBuyEvent, this)
        this.xufeiBtn.on('click', this.onBuyEvent, this)
        this.node.active = true
    }

    updateChoose(isShow){
        this.chooseNode.active = isShow
    }

    //更新装备状态
    updateEqit(isShow){
        this.gouNode.active = isShow
    }

    //购买 续费
    onBuyEvent(){
        if (this.viewBase == null || this.itemData == null){ return }
        this.viewBase.onBuyShopEvent(this)
    }

    //选择替换
    onChooseEvent(){
        if (this.viewBase == null || this.itemData == null){ return }
        this.viewBase.chooseItem(this)
    }


}